var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.1601C13.9344 10.1601 15.5 8.55865 15.5 6.58004C15.5 4.60143 13.9344 3 12 3C10.0656 3 8.5 4.60143 8.5 6.58004C8.5 8.55865 10.0656 10.1601 12 10.1601ZM14.4 11.183H14.1406C13.4906 11.5026 12.7688 11.6944 12 11.6944C11.2313 11.6944 10.5125 11.5026 9.85938 11.183H9.6C7.6125 11.183 6 12.8323 6 14.8653V19.4657C6 20.3128 6.67188 21 7.5 21H16.5C17.3281 21 18 20.3128 18 19.4657V14.8653C18 12.8323 16.3875 11.183 14.4 11.183Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/Default-Avatar.1bdc76dcc601466c70cf3d224ff8296e.svg";
export { ForwardRef as ReactComponent };